import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  scorm, booksTrack, report, statistic,
} from '@/api';
import {
  LIBRARY_XML_ORIGIN_URL,
  LIBRARY_ASSETS_ORIGIN_URL,
  LIBRARY_ASSETS_LOCAL_URL,
  DEVICE,
  IDENTITY_KEY_NAME,
} from '@/constants';
import { OS, getIdentity } from '@/utils/detectDevice';
import { quitBook, convertObject } from '@/utils/tools';
import Lockr from 'lockr';
import NativeAudioButton from '@/components/NativeAudioButton';
import Loading from '@/routes/components/Loading';
import RequestErrors from '@/components/RequestErrors';
import DiamondCenter from '@/components/Lottie/DiamondCenter';
import VERSION_NAME, { greaterAndEqualThan } from '@/utils/historyVersion';
import Header from './component/Header';
import MatchUp from './component/MatchUp';
import LineUp from './component/LineUp';
import ThinkOver from './component/ThinkOver';
import PickOut from './component/PickOut';
import PickOutTxt from './component/PickOutTxt';
import FillIn from './component/FillIn';
import LineUpTxt from './component/LineUpTxt';
import LineUpPic from './component/LineUpPic';
import SpellOut from './component/SpellOut';
import ThemeContext from './component/theme-context';
import ChangeBtn from './component/ChangeBtn';
import './style.less';

let transitionendNum = 0;
const exercisesType = [
  'match-up',
  'line-up',
  'think-over',
  'pick-out',
  'pick-out-txt',
  'fill-in',
  'line-up-txt',
  'line-up-pic',
  'spell-out',
];

@withRouter
class Exercises extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object,
  };

  constructor() {
    super();
    this.audioRef = React.createRef();
    this.headerRef = React.createRef();
    this.exerciseRef = React.createRef();
    this.diamondCenterRef = React.createRef();
  }

  state = {
    diamond: false,
    checkDis: true,
    retryBtn: false,
    diamondAnimation: false,
    exercisesTypeIndex: 0,
    exercisesData: null,
    diamondCenterStyle: null,
    params: null,
    isReport: false,
    audioSrc: '',
    playData: null,
    bookPage: 0,
    requestCode: 0,
  }

  componentWillMount() {
    this.setState({ params: this.props.match ? this.props.match.params : null }, () => {
      this.getScorm();
    });
  }

  getScorm = async () => {
    const GTE = await greaterAndEqualThan(VERSION_NAME.LIBRARY_SOUND_EFFECT);
    this.setState({
      ASSETS: {
        XML: `${LIBRARY_XML_ORIGIN_URL}Library/title_id/`,
        SOUNDS: OS.TYPE === DEVICE.PC
          ? `${LIBRARY_ASSETS_ORIGIN_URL}Idevice/action/rise/sounds/`
          : `${LIBRARY_ASSETS_LOCAL_URL}Library/sounds/`,
        AUDIO: (OS.TYPE !== DEVICE.PC && GTE)
          ? `${LIBRARY_ASSETS_LOCAL_URL}Library/sounds/`
          : `${LIBRARY_ASSETS_ORIGIN_URL}Idevice/action/rise/sounds/`,
      },
    }, () => {
      this.setState(({ ASSETS }) => ({
        components: {
          [exercisesType[0]]: {
            component: MatchUp,
            url: `${ASSETS.XML}match.xml`,
            audio: `${ASSETS.AUDIO}matchgame_helpTYPE.ogg`,
          },
          [exercisesType[1]]: {
            component: LineUp,
            url: `${ASSETS.XML}match.xml`,
            audio: `${ASSETS.AUDIO}match_help_lineup.ogg`,
          },
          [exercisesType[2]]: {
            component: ThinkOver,
            url: `${ASSETS.XML}title_id_Questions.xml`,
            audio: `${ASSETS.AUDIO}quiz_help_text_image_audio.ogg`,
          },
          [exercisesType[3]]: {
            component: PickOut,
            url: `${ASSETS.XML}title_id_Questions.xml`,
            audio: `${ASSETS.AUDIO}quiz_help_image.ogg`,
          },
          [exercisesType[4]]: {
            component: PickOutTxt,
            url: `${ASSETS.XML}title_id_Questions.xml`,
            audio: `${ASSETS.AUDIO}quiz_help_content.ogg`,
          },
          [exercisesType[5]]: {
            component: FillIn,
            url: `${ASSETS.XML}match.xml`,
            audio: `${ASSETS.AUDIO}match_help_fillin.ogg`,
          },
          [exercisesType[6]]: {
            component: LineUpTxt,
            url: `${ASSETS.XML}match.xml`,
            audio: `${ASSETS.AUDIO}match_help_text_to_text.ogg`,
          },
          [exercisesType[7]]: {
            component: LineUpPic,
            url: `${ASSETS.XML}match.xml`,
            audio: `${ASSETS.AUDIO}match_help_text_to_image.ogg`,
          },
          [exercisesType[8]]: {
            component: SpellOut,
            url: `${ASSETS.XML}match.xml`,
            audio: `${ASSETS.AUDIO}match_help_spell.ogg`,
          },
        },
      }));
    });
    const { params } = this.state;
    const stageId = params.stageId.split('-')[0];
    const reqParams = {
      ...params,
      stageId,
    };
    const result = await scorm.list(reqParams);
    const { code, data } = convertObject(result);
    code === 200 && this.init(data[0]);
    this.setState({ requestCode: code });
  };

  init = async ({ page }) => {
    const { params, components } = this.state;
    const exercises = [];
    page.forEach((item) => {
      item.subject_type && exercises.push(item);
    });
    const bookData = page.filter(item => item.vms_sco_type === 'SRS');
    const studentId = await getIdentity(IDENTITY_KEY_NAME.UID);
    const exercisesTypeIndex = Lockr.get(`${studentId}${params.id}`)
      && Lockr.get(`${studentId}${params.id}`).type === 'exercises'
      ? Lockr.get(`${studentId}${params.id}`).val
      : 0;
    Lockr.set(`${studentId}${params.id}`, { type: 'exercises', val: exercisesTypeIndex });
    const componentName = exercises[exercisesTypeIndex].subject_type.toLocaleLowerCase();
    const url = this.replaceStatusName(componentName, components).url.replace(new RegExp('title_id', 'g'), exercises[exercisesTypeIndex].title_id);
    const { code, data } = convertObject(scorm.xml(url));
    code === 200
      ? this.setState({
        exercisesData: exercises,
        exercisesTypeIndex,
        diamond: exercises[exercisesTypeIndex].get_diamond,
        bookPage: bookData.length - 1,
        xmlData: data,
      })
      : this.setState({ requestCode: 408 });
  }

  handleFinished = () => {
    const { diamond, exercisesData, exercisesTypeIndex } = this.state;
    !diamond && this.setState({ diamondAnimation: true });
    exercisesData[exercisesTypeIndex].get_diamond = true;
    this.postAddBooksTrack();
  }

  postAddBooksTrack = async () => {
    const { exercisesData, exercisesTypeIndex, params } = this.state;
    await booksTrack.post({
      scormid: parseInt(params.id, 10),
      scoid: exercisesData[exercisesTypeIndex].scoid,
      element: 'cmi.core.score.raw',
      value: '100',
      attempt: parseInt(params.attempt, 10),
    });
    this.setState({ isReport: true }, () => {
      statistic.post({ answer_num: 1 });
    });
  };

  handleBackHeader = () => {
    const diamondHerder = document.getElementById('exercisesDiamond');
    this.diamondCenterRef.current.className = 'diamond-center animation';
    const boundingClientRect = diamondHerder.getBoundingClientRect();
    this.setState({
      diamondCenterStyle: {
        left: `${boundingClientRect.x}px`,
        top: `${boundingClientRect.y}px`,
        transform: 'translate(0%, 0%)',
        width: `${diamondHerder.clientHeight}px`,
        height: `${diamondHerder.clientHeight}px`,
      },
    });
    this.diamondCenterRef.current.addEventListener('transitionend', this.handleTransitionend);
  }

  handleTransitionend = (e) => {
    transitionendNum += 1;
    transitionendNum === 5 && this.setState({ diamond: true, diamondAnimation: false }, () => {
      transitionendNum = 0;
      e.currentTarget.className = 'diamond-center';
      this.setState({
        diamondCenterStyle: {
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '',
          height: '',
        },
      });
    });
  }

  handleNext = async () => {
    const {
      exercisesTypeIndex,
      exercisesData,
      params,
      components,
    } = this.state;
    this.audioStop();
    if (exercisesTypeIndex + 2 <= exercisesData.length) {
      const componentName = exercisesData[exercisesTypeIndex + 1].subject_type.toLocaleLowerCase();
      const url = this.replaceStatusName(componentName, components).url.replace(new RegExp('title_id', 'g'), exercisesData[exercisesTypeIndex + 1].title_id);
      const { code, data } = convertObject(scorm.xml(url));
      code === 200
        ? this.setState({
          exercisesTypeIndex: exercisesTypeIndex + 1,
          diamond: exercisesData[exercisesTypeIndex + 1].get_diamond,
          diamondAnimation: false,
          checkDis: true,
          retryBtn: false,
          xmlData: data,
          diamondCenterStyle: {
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            width: '',
            height: '',
          },
        }, () => {
          Lockr.set(`${getIdentity(IDENTITY_KEY_NAME.UID)}${params.id}`, { type: 'exercises', val: this.state.exercisesTypeIndex });
          this.headerRef.current.audioEnd();
        })
        : this.setState({ requestCode: 408 });
    } else {
      this.props.history.push(`/report/${params.id}/${params.attempt}/${params.stage}/${params.stageId}`);
    }
  }

  handlePrev = async () => {
    const {
      exercisesTypeIndex,
      exercisesData,
      params,
      isReport,
      bookPage,
      components,
    } = this.state;
    this.audioStop();
    const studentId = await getIdentity(IDENTITY_KEY_NAME.UID);
    if (exercisesTypeIndex !== 0) {
      const componentName = exercisesData[exercisesTypeIndex - 1].subject_type.toLocaleLowerCase();
      const url = this.replaceStatusName(componentName, components).url.replace(new RegExp('title_id', 'g'), exercisesData[exercisesTypeIndex - 1].title_id);
      const { code, data } = convertObject(scorm.xml(url));
      code === 200
        ? this.setState({
          exercisesTypeIndex: exercisesTypeIndex - 1,
          diamond: exercisesData[exercisesTypeIndex - 1].get_diamond,
          diamondAnimation: false,
          checkDis: true,
          retryBtn: false,
          xmlData: data,
          diamondCenterStyle: {
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            width: '',
            height: '',
          },
        }, () => {
          this.headerRef.current.audioEnd();
          Lockr.set(`${studentId}${params.id}`, { type: 'exercises', val: this.state.exercisesTypeIndex });
        })
        : this.setState({ requestCode: 408 });
    } else {
      isReport && await report.list(params.id, params.attempt);
      Lockr.set(`${studentId}${params.id}`, { type: 'reading', val: bookPage });
      this.props.history.push(`/reading_report/${params.id}/${params.attempt}/${params.stage}/${params.stageId}`);
    }
  }

  handleChangeBtn = (check) => {
    this.setState({ checkDis: check });
  }

  handleRetryBtn = (retry) => {
    this.setState({ retryBtn: retry });
  }

  handleCheck = () => {
    this.exerciseRef.current.handleCheck();
  }

  handleRetry = () => {
    this.exerciseRef.current.handleRetry();
  }

  replaceStatusName = (keyName, hashTable) => hashTable[keyName];

  renderExercises = (componentName, index) => {
    const {
      exercisesData, components, ASSETS, xmlData,
    } = this.state;
    const ComponentName = this.replaceStatusName(componentName, components).component;
    return (
      <ComponentName
        finished={this.handleFinished}
        exercisesData={xmlData}
        url={`${LIBRARY_ASSETS_ORIGIN_URL}Library/${exercisesData[index].title_id}/`}
        changeBtn={this.handleChangeBtn}
        retryBtn={this.handleRetryBtn}
        ref={this.exerciseRef}
        diamond={this.state.diamond}
        audioStop={this.audioStop}
        audioPlay={this.audioPlay}
        matchType={exercisesData[index].match_type}
        layout={exercisesData[index].layout.split(' ')[0]}
        soundsUrl={ASSETS.SOUNDS}
      />
    );
  }

  handleClose = async () => {
    this.audioStop();
    const { params, isReport } = this.state;
    isReport && await report.list(params.id, params.attempt);
    quitBook({ params, push: this.props.history.push });
  }

  audioEnd = () => {
    const { playData } = this.state;
    const {
      headerRef: { current: header },
      exerciseRef: { current: exercise },
    } = this;
    header && header.audioEnd && header.audioEnd();
    exercise && exercise.audioEnd && exercise.audioEnd(playData);
  }

  changeBtnStatus = (playData) => {
    const {
      headerRef: { current: header },
      exerciseRef: { current: exercise },
    } = this;
    playData.type === 'header'
      ? header && header.audioPlay && header.audioPlay()
      : exercise && exercise.audioPlay && exercise.audioPlay(playData);
  }

  audioStop = () => {
    this.audioRef.current.stop();
  }

  audioPlay = (src, data) => {
    this.setState({ audioSrc: src, playData: data }, () => {
      this.audioRef.current.play();
    });
    OS.TYPE === DEVICE.PC && (!this.isSoundEffect(src) || data.type === 'header') && this.changeBtnStatus(data);
  }

  isSoundEffect = src => src.indexOf('rise/sounds/') > -1;

  render = () => {
    const {
      diamond,
      exercisesTypeIndex,
      diamondAnimation,
      exercisesData,
      diamondCenterStyle,
      audioSrc,
      playData,
      components,
      xmlData,
      requestCode,
    } = this.state;
    const exercises = exercisesData ? exercisesData[exercisesTypeIndex] : null;
    const exercisesTypeName = exercises ? exercises.subject_type.toLocaleLowerCase() : null;
    return (
      <div>
        {requestCode === 0 ? <Loading /> : null}
        {requestCode === 408 ? <RequestErrors callback={this.handleClose} /> : null}
        {exercises
          ? (
            <ThemeContext.Provider value={exercisesTypeName}>
              <div className={`exercises-container ${exercisesTypeName}`}>
                <div className="exercises-wrapper">
                  <Header
                    audioSrc={exercisesTypeName === 'match-up' && exercises.layout ? this.replaceStatusName(exercisesTypeName, components).audio.replace('TYPE', `_${exercises.layout.split(' ')[0]}`) : this.replaceStatusName(exercisesTypeName, components).audio.replace('TYPE', '')}
                    diamond={diamond}
                    back={this.handleClose}
                    audioStop={this.audioStop}
                    audioPlay={this.audioPlay}
                    ref={this.headerRef}
                  />
                  {xmlData && this.renderExercises(exercisesTypeName, exercisesTypeIndex)}
                </div>
                <ChangeBtn
                  prev={this.handlePrev}
                  next={this.handleNext}
                  checkFunc={this.handleCheck}
                  retryFunc={this.handleRetry}
                  disabled={this.state.checkDis}
                  retryBtn={this.state.retryBtn}
                />
                {
                  diamondAnimation ? <div className="diamond-center" ref={this.diamondCenterRef} style={{ ...diamondCenterStyle }}><DiamondCenter callback={this.handleBackHeader} /></div> : null
                }
                <div className="clear" />
              </div>
            </ThemeContext.Provider>
          )
          : null
        }
        <NativeAudioButton
          src={audioSrc}
          playData={playData}
          audioEnd={this.audioEnd}
          changeBtnStatus={this.changeBtnStatus}
          ref={this.audioRef}
        />
      </div>
    );
  }
}

export default Exercises;
